import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: [],
    available: []
};
export var Reducer = createSlice({
    name: 'brokers',
    initialState: initialState,
    reducers: {
        setAvailable: function setAvailable(state, brokers) {
            state.available = brokers.payload;
        },
        set: function set(state, brokers) {
            state.data = brokers.payload;
        },
        add: function add(state, data) {
            var broker = {
                id: data.payload.id,
                name: data.payload.name,
                separator: data.payload.separator,
                hasUniqueTradeId: data.payload.hasUniqueTradeId
            };
            state.data.push(broker);
        },
        del: function del(state, id) {
            var index = state.data.findIndex(function (el) {
                return el.id === id.payload;
            });
            state.data.splice(index, 1);
        },
        makeUnique: function makeUnique(state, brokers) {
            state.data = state.data.map(function (item) {
                if (item.id === brokers.payload.id) {
                    return brokers.payload;
                }
                return item;
            });
        }
    }
});
var _Reducer$actions = Reducer.actions, add = _Reducer$actions.add, set = _Reducer$actions.set, del = _Reducer$actions.del, setAvailable = _Reducer$actions.setAvailable, makeUnique = _Reducer$actions.makeUnique;
export { add, set, del, setAvailable, makeUnique };
export default Reducer.reducer;
